module.exports = __webpack_public_path__ + "static/img/default.0760f6fe.jpg";